import * as React           from 'react';
import IconButton           from '@mui/material/IconButton';
import Toolbar              from '@mui/material/Toolbar';
import SvgIcon              from '@mui/material/SvgIcon';
import Box                  from '@mui/material/Box';
import Link                 from '@mui/material/Link';
import {
    Drawer as MuiDrawer,
    styled,
    Typography
}                           from '@mui/material';
import { ToggleProps }      from 'ui/components/Dashboard';
import {
    ReactComponent as FunexpectedIcon
}                           from 'images/funexpected.svg';
import ListMenu             from 'ui/components/dashboard-components/ListMenu';
import {
    COPYRIGHT_EMAIL_TO,
    COPYRIGHT_EMAIL_US
}                           from 'config/config';

export const drawerWidth: number = 310;

const Drawer = styled(MuiDrawer, { shouldForwardProp: (prop) => prop !== 'open' })(
    ({ theme, open }) => ({
        '& .MuiDrawer-paper': {
            position: 'relative',
            whiteSpace: 'nowrap',
            backgroundColor: theme.palette.background.default,
            width: drawerWidth,
            border: 'none',
            transition: theme.transitions.create('width', {
                easing: theme.transitions.easing.sharp,
                duration: theme.transitions.duration.enteringScreen,
            }),
            boxSizing: 'border-box',
            ...(!open && {
                overflowX: 'hidden',
                transition: theme.transitions.create('width', {
                    easing: theme.transitions.easing.sharp,
                    duration: theme.transitions.duration.leavingScreen,
                }),
                width: theme.spacing(7),
                [theme.breakpoints.up('sm')]: {
                    width: theme.spacing(9),
                },
            }),
        },
    }),
);

export default function LeftDrawer(props: ToggleProps) {
    return (
        <Drawer
            variant="permanent"
            open={props.open}
        >
            <Toolbar
                sx={{
                    display: 'flex',
                    alignItems: 'left',
                    justifyContent: 'flex-start',
                    px: [1],
                    height: 80,
                }}
            >
                <Link href="/classes">
                <IconButton
                    disableRipple
                    disableFocusRipple
                    disableTouchRipple
                    edge="start"
                    color="inherit"
                    sx={{ml: 1}}
                    style={{ backgroundColor: 'transparent' }}
                >
                    <SvgIcon
                        focusable={false}
                        component={FunexpectedIcon}
                        viewBox='0 0 153 14'
                        color="secondary"
                        sx={{ width: 180, height: 17 }}
                    />
                </IconButton>
                </Link>
            </Toolbar>
            <ListMenu/>
            <Box
                display='flex'
                sx={{marginTop: 'auto', mx: 3, gap: 1, mb: 3}}
            >
                <Typography variant="body1" color="text.secondary">
                    {COPYRIGHT_EMAIL_US}
                    <br/>
                    <Link color="inherit"href={`mailto:${COPYRIGHT_EMAIL_TO}`}>
                        {COPYRIGHT_EMAIL_TO}
                    </Link>
                    <br/>
                    {'©'}{new Date().getFullYear()}{' Funexpected LTD'}
                </Typography>
            </Box>
            {/*<Box
                display='flex'
                sx={{marginTop: 'auto', mx: 3, gap: 1, mb: 2}}
            >
                <Link
                    color='secondary'
                    underline='none'
                    variant='caption'
                >
                        Privacy
                </Link>
                <Typography variant='caption' color='secondary'>
                    ·
                </Typography>
                <Link
                    color='secondary'
                    underline='none'
                    variant='caption'
                >
                        Terms
                </Link>
                <Typography variant='caption' color='secondary'>
                    ·
                </Typography>
                <Link
                    color='secondary'
                    underline='none'
                    variant='caption'
                >
                        Help
                </Link>
                </Box>*/}
        </Drawer>
    )
};